export const currencyFormat = (
  amount,
  includeDecimals = true,
  symbol
) => {
  return `${symbol ?? ''}${new Intl.NumberFormat('es-Us', {
    minimumFractionDigits: includeDecimals ? 2 : 0,
    maximumFractionDigits: includeDecimals ? 2 : 0,
  }).format(amount)}`;
};

export const splitPriceByDecimal = (price) => {
  const priceString = currencyFormat(price, true, '$');
  const [integer, decimal] = priceString.split('.');
  return { integer, decimal };
};
